module.exports = __webpack_public_path__ + "3.jpg?4599749d2415f4a8e5e3c2ce323551ab";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3.jpg
// module id = 22
// module chunks = 0